import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { callOwnerTransferred } from 'features/call/call-base/store/callSlice';

interface TransferActiveCallOwnerPayload {
  userId: number;
  name: string;
}

export const transferActiveCallOwner = createAsyncThunk(
  'call/transferActiveCallOwner',
  async (payload: TransferActiveCallOwnerPayload, { dispatch }) => {
    if (!payload.userId) {
      return {
        transferred: false,
      };
    }

    dispatch(callOwnerTransferred(payload));
    dispatch(
      sendAnalyticsInfo({
        event: 'callOwnerTransferred',
        message: `Call owner transferred to ${payload.name} (ID: ${payload.userId})`,
      })
    );

    return {
      transferred: true,
    };
  }
);
